import { Table } from '@ui';
import styled from 'styled-components';

export const TagsSC = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  .tags_action_button {
    cursor: pointer;
  }
`;

export const TableSC = styled(Table)`
  tbody {
    tr {
      td:last-child {
        text-align: right;
      }
    }
  }
` as typeof Table;
